type Props = {
  color?: string;
};

export default function IconCheck(props: Props) {
  const { color = "white" } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill={color}>
      <path
        d="M18.3386 0.501258C17.923 0.514458 17.529 0.689111 17.2401 0.988131C13.326 4.91072 10.3623 8.16488 6.67919 11.911L2.63461 8.49057C2.47477 8.35449 2.2897 8.2512 2.08996 8.18665C1.89021 8.1221 1.67971 8.09753 1.47047 8.11434C1.26123 8.13114 1.05734 8.18899 0.870461 8.28459C0.683578 8.38019 0.517356 8.51166 0.381287 8.6715C0.245217 8.83134 0.141964 9.01643 0.0774238 9.21618C0.0128839 9.41593 -0.011679 9.62643 0.00513744 9.83567C0.0219539 10.0449 0.0798201 10.2488 0.175433 10.4357C0.271045 10.6225 0.402531 10.7887 0.562382 10.9248L5.75543 15.3189C6.06174 15.581 6.4558 15.7177 6.85863 15.7015C7.26145 15.6853 7.64326 15.5174 7.92752 15.2315C12.2215 10.9284 15.2841 7.4847 19.512 3.24758C19.745 3.02263 19.9041 2.7322 19.9683 2.41479C20.0325 2.09737 19.9987 1.76795 19.8715 1.47015C19.7442 1.17235 19.5295 0.920243 19.2558 0.747218C18.982 0.574193 18.6622 0.488411 18.3386 0.501258Z"
        fill={color}
      />
    </svg>
  );
}
